import React from 'react';

import { useIntl } from 'react-intl';

import styles from './CouponApply.module.scss';
import messages from './messages';

const CouponApplySuccess = ({ couponAutoAccept, goToUsedCoupons }) => {
  const intl = useIntl();

  return (
    <div className={styles.card}>
      <div className={styles.icon}>
        <span role="img" aria-label="" style={{ fontSize: '3rem' }}>
          ✅
        </span>
      </div>
      <h1 className={styles.title}>{intl.formatMessage(messages.waitingForAcceptanceTitle)}</h1>
      {couponAutoAccept !== 'accepted' && (
        <p className={styles.description}>{intl.formatMessage(messages.requestHasBeenSentMessage)}</p>
      )}
      <button type="button" className={styles.actionBtn} onClick={goToUsedCoupons}>
        {intl.formatMessage(messages.goToUsedCouponsText)}
      </button>
    </div>
  );
};

export default CouponApplySuccess;